const ICON_STYLE = /<IconStyle><Icon><href>https:\/\/api.tiles.mapbox.com\/v3\/marker\/pin-m\+([A-Fa-f0-9]{6}).png<\/href><\/Icon><\/IconStyle>/g;
const SHADED_DOT = 'https://maps.google.com/mapfiles/kml/shapes/shaded_dot.png';

export const TO_KML_OPTIONS = {
  name: 'name',
  description: 'description',
  simplestyle: true,
  timestamp: 'timestamp',
};

// Replace the <IconStyle> tag for a Point <Style> tag.
// - Hides the label for Points
// - Updates the icon link
// - Makes the icon smaller
// - Formats the icon color as ABGR (alpha/opacity, blue, green, red)
const replacePointStyles = (_string: string, match: string) => {
  const [r, R, g, G, b, B] = match.toLowerCase();
  return `
    <LabelStyle>
      <scale>0</scale>
    </LabelStyle>
    <IconStyle>
      <color>ff${b}${B}${g}${G}${r}${R}</color>
      <scale>0.5</scale>
      <Icon><href>${SHADED_DOT}</href></Icon>
    </IconStyle>
  `;
};

// Edits the <Style> tag for Point Placemarks. The tokml library is limited in
// style features and contains broken links to Mapbox icons.
export const editPointStyles = (kml: string): string => {
  return kml.replaceAll(ICON_STYLE, replacePointStyles);
};
